import intl from 'intl';
import 'intl/locale-data/jsonp/fr-CA';
import 'intl/locale-data/jsonp/en-CA';

function parseCurrencyValue(lang: string, currency: string) {
  const rawNumber = currency.replace('$', '');
  switch (lang) {
    case 'fr':
      return rawNumber.replace(/,/g, '.').replace(/ /g, '').replace(/\xa0/g, '');
    case 'en':
      return rawNumber.replace(/,/g, '');
    default:
      throw new Error(`parseCurrencyValue called with unsupported locale: ${lang}`);
  }
}

export function parseCurrency(lang: string, value: number) {
  return parseFloat(parseCurrencyValue(lang, value));
}

export function formatCurrency(lang: string, value: number) {
  const numericValue = parseCurrencyValue(lang, value.toString());
  return intl.NumberFormat(lang + '-CA', { style: 'currency', currency: 'CAD' }).format(numericValue);
}



// WEBPACK FOOTER //
// ./src/statsradio/helpers/currency/currency.js